import { useMutation } from '@apollo/client'
import { useToast } from 'components/Dashboard/Toast'
import { markKitObservedMutation } from 'components/Dashboard/Video/KitChecklist'
import {
  MarkKitObservedMutation,
  MarkKitObservedMutationVariables,
} from 'components/Dashboard/Video/__generated__/MarkKitObservedMutation'
import { Modal2 } from 'components/Modal'
import SubmitButton from 'components/SubmitButton'
import { Form, Formik } from 'formik'

interface MarkKitObservedModalProps {
  kitId: string
  onRequestClose: () => void
}

const MarkKitObservedModal = ({ kitId, onRequestClose }: MarkKitObservedModalProps) => {
  const [markKitObserved] = useMutation<MarkKitObservedMutation, MarkKitObservedMutationVariables>(
    markKitObservedMutation
  )

  const { addToast } = useToast()

  return (
    <Modal2 isOpen onRequestClose={onRequestClose} header="Mark Kit Observed">
      <Formik
        initialValues={{}}
        onSubmit={async (values, { setStatus }) => {
          try {
            const resp = await markKitObserved({
              variables: {
                input: {
                  kitId,
                },
              },
            })

            if (!resp.data.markKitObserved.success) {
              throw new Error('Something went wrong')
            }

            onRequestClose()
            addToast({
              messageType: 'success',
              title: 'Kit Observed',
              content: <>Kit marked as observed</>,
              timeout: 5000,
            })
          } catch (err) {
            setStatus({ error: err.message })
          }
        }}
      >
        {({ isSubmitting, status }) => (
          <Form>
            <div className="buttons is-right mt-5">
              <SubmitButton className="is-primary" submitting={isSubmitting} disabled={isSubmitting}>
                Mark Kit Observed
              </SubmitButton>
            </div>
            {status?.error && (
              <article className="message is-danger">
                <div className="message-body">Failed: {status.error}</div>
              </article>
            )}
          </Form>
        )}
      </Formik>
    </Modal2>
  )
}

export default MarkKitObservedModal
